import { Layout } from 'antd';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouterConfig } from 'src/routers/urlConfig';
import SideMenuLayout from './SideMenuLayout';
import { ClickParam } from 'antd/lib/menu';

const { Sider } = Layout;

interface SideLayoutProps extends RouteComponentProps {
  pathName: string;
  menuItem: RouterConfig.IMenuItems | undefined;
  updateMenu: (path: string) => void;
}

interface ISideLayoutState {
  collapsed: boolean;
  logo: string;
}

class SideLayout extends React.Component<SideLayoutProps, ISideLayoutState> {
  state: ISideLayoutState = {
    logo: require('src/assets/imgs/logo_big.svg'),
    collapsed: false,
  };
  constructor(props: SideLayoutProps) {
    super(props);
  }

  onCollapse = (collapsed: boolean) => {
    this.setState({
      logo: collapsed ? require('src/assets/imgs/logo_small.svg') : require('src/assets/imgs/logo_big.svg'),
      collapsed,
    });
  };

  handleClick = (param: ClickParam) => {
    this.props.updateMenu(param.key);
  };

  render() {
    const { pathName, menuItem } = this.props;
    const menus: RouterConfig.IMenuData[] = !!menuItem ? menuItem.menus : [];
    return (
      <Sider collapsible={true} collapsed={this.state.collapsed} onCollapse={this.onCollapse} width={200} className="side-box">
        <div className="side-logo">
          <img src={this.state.logo} alt="logo" style={{ height: '100%' }} />
        </div>
        <SideMenuLayout
          menus={menus}
          className="side-menu-layout"
          style={{ overflow: 'auto', borderRight: 0, height: 'calc(100% - 64px)' }}
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[RouterConfig.Urls.default]}
          defaultOpenKeys={[RouterConfig.Urls.user]}
          selectedKeys={[pathName]}
          onClick={this.handleClick}
        />
      </Sider>
    );
  }
}

export default withRouter(SideLayout);



// WEBPACK FOOTER //
// ./src/components/layouts/SideLayout.tsx